import type {SetOptional} from 'type-fest'

import type {StoreDetailParams} from '@/lib/food/foodModel'
import {getStoreDetailById} from '@/lib/food/storeService'

export function getUseStoreDetailsQueryOptions(params: SetOptional<StoreDetailParams, 'store_id'>) {
  return queryOptions({
    queryKey: ['storeDetail', params],
    queryFn: params.store_id
      ? async () =>
          getStoreDetailById({
            store_id: params.store_id ?? '',
            pickup: params.pickup ?? false,
            include_quote: params.include_quote ?? true,
            quote_preference: params.quote_preference ?? 'first_available',
            include_customizations: params.include_customizations ?? true,
            user_latitude: params.user_latitude,
            user_longitude: params.user_longitude,
            user_street_num: params.user_street_num,
            user_street_name: params.user_street_name,
            user_city: params.user_city,
            user_state: params.user_state,
            user_zipcode: params.user_zipcode,
            user_country: params.user_country,
            // image_height: params.image_height ?? 300,
            // image_width: params.image_width ?? 300,
            available: params.available ?? true,
            include_fees: params.include_fees ?? true,
            include_menu: params.include_menu ?? true,
          })
      : skipToken,
  })
}

export default function useGetStoreDetails(params: SetOptional<StoreDetailParams, 'store_id'>) {
  return useQuery(getUseStoreDetailsQueryOptions(params))
}
